import { Controller } from "stimulus";

export default class extends Controller {
  static values = {
    file: String,
    filename: String,
    uploaded: Boolean,
  };

  upload() {
    if (this.uploadedValue) return;

    const button = this.element.querySelector("[data-action*='upload']");
    button.style.width = button.offsetWidth + "px";
    button.disabled = true;
    button.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status"></span>';

    const csrfToken = document.querySelector(
      "meta[name='csrf-token']",
    )?.content;

    fetch("/admin/maps/queue/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken,
      },
      body: JSON.stringify({
        file: this.fileValue,
        filename: this.filenameValue,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "OK") {
          this.uploadedValue = true;
          button.remove();
          const badge = document.createElement("span");
          badge.className = "badge bg-green-lt";
          badge.textContent = "Uploaded";
          this.element
            .querySelector("[data-map-queue-row-badge]")
            .appendChild(badge);
        } else {
          alert("Upload failed: " + (data.message || "Unknown error"));
          button.disabled = false;
          button.innerHTML = "Upload";
        }
      })
      .catch((error) => {
        alert("Upload error: " + error);
        button.disabled = false;
        button.innerHTML = "Upload";
      });
  }
}
